export function buildQmsQuestionBankListTourSteps() {
  return [
    {
      id: "welcome",
      placement: "center",
      title: "Question master",
      body: "Build your organisation question bank here. Questions are reused across many quizzes — create them once, assign them in the Quizzes tab.",
    },
    {
      id: "toolbar",
      target: '[data-tour="qms-question-list-toolbar"]',
      placement: "bottom",
      title: "Toolbar",
      body: "Add question opens the entry form. Import Excel opens a full-screen grid for bulk upload. Refresh reloads the list.",
    },
    {
      id: "table",
      target: '[data-tour="qms-question-list-table"]',
      placement: "top",
      title: "Question table",
      body: "Preview text, option count, and how many quizzes use each question. Edit updates the bank. Delete is blocked when a question is used in a quiz.",
    },
    {
      id: "guide",
      target: '[data-tour="qms-question-list-guide"]',
      placement: "bottom",
      title: "Page guide",
      body: "Use Guide to replay this tour. The Add question popup has a separate guide for the entry form layout.",
    },
    {
      id: "done",
      placement: "center",
      title: "You are ready",
      body: "Add questions individually or import from Excel, then switch to the Quizzes tab to map them into quizzes.",
    },
  ];
}
